import type { RankingCategory } from './RankingView.js';

interface MyRankBannerProps {
  rank: number;
  score: number;
  /** TOP100の最低スコア（表示中の100位のスコア）。未定の場合は null */
  thresholdScore: number | null;
  category: RankingCategory;
}

export function MyRankBanner({ rank, score, thresholdScore, category }: MyRankBannerProps) {
  const needed = thresholdScore !== null ? thresholdScore - score + 1 : null;
  const categoryLabel = category === 'checkin' ? 'チェックイン' : 'スポット登録';

  return (
    <div className="mb-3 px-4 py-3 bg-primary-50 border border-primary-100 rounded-lg flex items-center gap-3">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0 text-primary"
      >
        <path
          d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div className="text-sm text-primary-700">
        <span className="font-semibold">現在 {rank} 位</span>
        {needed !== null && needed > 0 ? (
          <span>
            。TOP100まであと <span className="font-semibold">{needed} 件</span>の{categoryLabel}！
          </span>
        ) : (
          <span>。TOP100入りまで{categoryLabel}を続けよう！</span>
        )}
      </div>
    </div>
  );
}
